module.exports = __webpack_public_path__ + "static/media/MPLUS1p-Regular.9365e131.ttf";